import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LanguageProvider } from './i18n/LanguageContext';
import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './components/HomePage';
import AboutPage from './components/AboutPage';
import LeadershipPage from './components/LeadershipPage';
import EventsPage from './components/EventsPage';
import GetInvolvedPage from './components/GetInvolvedPage';
import GivePage from './components/GivePage';
import ContactPage from './components/ContactPage';
import { Toaster } from './components/ui/sonner';
import './App.css';

function App() {
  return (
    <LanguageProvider>
      <div className="App min-h-screen flex flex-col">
        <BrowserRouter>
          <Header />
          <main className="flex-1">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/leadership" element={<LeadershipPage />} />
              <Route path="/events" element={<EventsPage />} />
              <Route path="/get-involved" element={<GetInvolvedPage />} />
              <Route path="/give" element={<GivePage />} />
              <Route path="/contact" element={<ContactPage />} />
            </Routes>
          </main>
          <Footer />
        </BrowserRouter>
        <Toaster />
      </div>
    </LanguageProvider>
  );
}

export default App;
